import { apiCall } from "../service/api-service";

export const getItemsListApi = async (params) => {
  return apiCall("GET", `item${params}`);
};

export const createItemApi = async (data) => {
  return apiCall("POST", "item", data);
};

export const getItemEditApi = async (id) => {
  return apiCall("GET", `item/edit/${id}`);
};

export const updateItemApi = async (id, data) => {
  return apiCall("PUT", `item/${id}`, data);
};

export const getItemViewApi = async (id) => {
  return apiCall("GET", `item/view/${id}`);
};

export const bulkDeleteItemsApi = async (ids) => {
  const data = Array.isArray(ids) ? { ids } : ids;
  return apiCall("DELETE", "item/bulk_delete", data);
};

export const updateItemStatusApi = async (id, status) => {
  return apiCall("PUT", `item/update_status/${id}`, { status });
};

export const getItemBrandsApi = async (search) => {
  return apiCall("GET", `item/get_brands${search ? `?search=${encodeURIComponent(search)}` : ""}`);
};

export const exportItemsApi = async (params) => {
  return apiCall("GET", `item/export${params}`);
};

export const uploadItemAttachmentApi = async (id, upload) => {
  return apiCall("POST", `item/upload_attachment/${id}`, { upload });
};

export const deleteItemAttachmentApi = async (id) => {
  return apiCall("DELETE", `item/delete_attachment/${id}`);
};

export const getItemUploadImageApi = async (id) => {
  return apiCall("GET", `item/upload_image/${id}`);
};
